export default __webpack_public_path__ + "static/media/President_apdp.91722452.png";